import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ControlClinicalEscalationIcon from 'components/atoms/icons/controlClinicalEscalationIcon';
import { useClinicEscalation } from 'infrastructure/hooks/control-panel';
import PatientControlButton from 'components/atoms/patentControlButton';
import ClinicEscalationFormModal from 'components/organisms/controlPanel/clinicalEscalation/modal';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import { useGetClinicEscalationValues } from '../hooks/useGetClinicEscalationValues';

import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
  clinicGuid?: string;
}

const ClinicalEscalationsControls: React.FC<IProps> = (props) => {
  const { module, patientGuid, clinicGuid } = props;
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const { isCombinedModule, isReadOnlyRole, isBlockRpmModule } = useAccess({
    module,
    patientGuid,
  });

  const { defaultClinicEscalationValues, loading } =
    useGetClinicEscalationValues({ patientGuid });

  const { sendClinicEscalation, sendClinicEscalationLoading } =
    useClinicEscalation({
      onSuccess() {
        setOpen(false);
      },
    });

  const disabled =
    (isCombinedModule && (isReadOnlyRole || isBlockRpmModule)) ||
    sendClinicEscalationLoading;

  return (
    <>
      <PatientControlButton
        label={t('labels.clinicalEscalations')}
        Icon={ControlClinicalEscalationIcon}
        loading={sendClinicEscalationLoading || loading}
        disabled={disabled}
        active
        handleClick={() => setOpen(true)}
      />

      {open && (
        <ClinicEscalationFormModal
          isOpen={open}
          closeModal={() => setOpen(false)}
          onSubmit={sendClinicEscalation}
          defaultValue={defaultClinicEscalationValues}
          submitLoading={sendClinicEscalationLoading}
          clinicGuid={clinicGuid}
        />
      )}
    </>
  );
};

export default ClinicalEscalationsControls;
